import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const AiConversationsPage = lazy(() => import('./AiConversationsPage'));
const AiProjectsPage = lazy(() => import('./AiProjectsPage'));
const AiProjectDetailPage = lazy(() => import('./AiProjectDetailPage'));

export const aiOversightRoutes: RouteObject[] = [
  {
    path: 'ai/conversations',
    element: (
      <ProtectedRoute action="aiOversight:view">
        <AiConversationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'ai/projects',
    element: (
      <ProtectedRoute action="aiOversight:view">
        <AiProjectsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'ai/projects/:id',
    element: (
      <ProtectedRoute action="aiOversight:view">
        <AiProjectDetailPage />
      </ProtectedRoute>
    ),
  },
];
